import { isPlatformBrowser } from '@angular/common';
import { setWorkerUrl } from 'mapbox-gl/esm';

let configured = false;

export function configureMapboxGl(platformId: object): void {
  if (!isPlatformBrowser(platformId) || configured) {
    return;
  }
  const workerPath = 'assets/mapbox/mapbox-gl-csp-worker.js';
  const workerUrl = new URL(workerPath, document.baseURI).href;
  setWorkerUrl(workerUrl);
  configured = true;
}
